interface IOption<T> {
    value: T,
    label: string
}

interface IProps<T> {
    label: string,
    value: T | null,
    options: IOption<T>[],
    disabled: boolean,
    onChange: (value: T) => void
}

const SegmentedChoice = <T,>({ label, value, options, disabled, onChange }: IProps<T>) => (
    <div className='segmented' role='radiogroup' aria-label={label}>
        {options.map(option =>
            <button
                key={String(option.value)}
                type='button'
                role='radio'
                aria-checked={value === option.value}
                className={value === option.value ? 'btn active' : 'btn'}
                disabled={disabled}
                onClick={() => onChange(option.value)}>
                {option.label}
            </button>
        )}
    </div>
);

export default SegmentedChoice;
